// root '../../../';

// dependencies
import { Child } from 'pym.js';
import { select } from 'd3-selection';
import * as d3 from 'd3';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
import config from './config';
import graphic from './graphic';

// styles
import './styles/index.scss';

/* develblock:start */
import meta from './data/meta.json';

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();
};

function draw(initialWidth) {
  const container = select('#graphic');
  container.html('');

  const fallbackWidth = container.node().clientWidth || 600;
  const safeWidth = initialWidth !== fallbackWidth ? fallbackWidth : initialWidth;
  const isMobile = safeWidth <= 500;

  const heightMultiplier = 9 / 16;
  const chartWidth = isMobile ? safeWidth : safeWidth / 2;
  const chartHeight = heightMultiplier * chartWidth;

  const props = { initialWidth: chartWidth, initialHeight: chartHeight, isMobile };

  graphic(props, container, isMobile);
}
